import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, IconButton, MenuItem, Select, FormControl, SelectChangeEvent } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import { GREEN_MAIN } from '../../../../theme/colors';
import { GREEN_LOGO } from '../../../../theme/colors';
import { alpha } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { BLUE_LIGHT_RGB_BORDER } from '../../../../theme/colors';

interface AssociationApprovalsProps {
    approved: boolean; // Valore iniziale passato come prop (true/false)
    resetValue: boolean; // Valore da usare per il reset
    handleChange: (value: string, key: string) => void; // Funzione per aggiornare lo stato
    viewButtonReset?: boolean;
}

const EnableUser: React.FC<AssociationApprovalsProps> = ({ approved, resetValue, handleChange, viewButtonReset = true }) => { 
    const { t } = useTranslation();
    const theme = useTheme();

    const [selectedValue, setSelectedValue] = React.useState<boolean>(approved);

    const handleSelectChange = (event: SelectChangeEvent<string>) => {
        const value = event.target.value;
        const boolVal: boolean = value === 'true' ? true : false;  
        setSelectedValue(boolVal);
        handleChange(value, 'enabledUser'); 
    };
    
    const handleReset = () => {
        const boolVal: string = resetValue ? 'true' : 'false'; 
        setSelectedValue(resetValue);
        handleChange(boolVal, 'enabledUser');
    };

    return (
        <Box sx={{display:'flex'}}>
            <FormControl fullWidth>
                <Select
                    value={selectedValue.toString()}
                    onChange={handleSelectChange}
                    sx={{
                        marginBottom: 0,
                        marginTop: 0,
                        height: '45px',
                        '& .MuiOutlinedInput-notchedOutline': {
                            color: GREEN_MAIN,
                        },
                        '& .MuiSelect-select': {
                            padding: '12px 12px',
                            lineHeight: 1.4,
                            color: "grey",
                            fontSize: '1rem',
                            textTransform: 'none'
                        },
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                            borderColor: GREEN_LOGO,
                            color: GREEN_MAIN,
                        },
                        '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                            borderColor: 'grey !important',
                        }
                    }}
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                '& .MuiMenuItem-root': {
                                    fontSize: '1rem',
                                    color: GREEN_MAIN,
                                    '&:hover': {
                                        backgroundColor: 'rgba(0, 128, 0, 0.08)'
                                    },
                                    '&.Mui-selected': {
                                        backgroundColor: 'rgba(0, 128, 0, 0.12)',
                                        '&:hover': {
                                            backgroundColor: 'rgba(0, 128, 0, 0.16)'
                                        }
                                    }
                                }
                            }
                        }
                    }}
                >
                    <MenuItem value="true">{t("Enable")}</MenuItem>
                    <MenuItem value="false">{t("Disable")}</MenuItem>
                </Select>
            </FormControl>
    
            {viewButtonReset && (
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                    <IconButton onClick={handleReset} sx={{ 
                        width:'45px', 
                        height:'45px',
                        color: GREEN_MAIN
                    }}>
                        <ClearIcon />
                    </IconButton>
                </Box>
            )}
        </Box>
    );
}

export default EnableUser;